import React, { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';

import {
  Form as BaseForm,
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from '../../../ui/FormElement';
import routes from '../../../app/routes';

export default function Form({ closeForm, manager }) {
  const FormSchema = Yup.object().shape({
    text: Yup.string().typeError('Invite Text is required'),
  });

  const [loader, setLoader] = useState(false);

  const defaultInviteText = `Hi ${manager ? manager.attributes.first_name : ''},

Welcome to LeggUP! We're pleased to share this invitation with you to the LeggUP Manager Portal.

As a people leader, you have the opportunity to create your own user account and explore the benefits that Talent Insurance can provide to your team.
    
Talent Insurance is a great way to protect your team's investment in their people and provide personalized programs to your leaders, managers and employees.
    
We hope you take advantage of this amazing opportunity!
`;

  const defaultBillingInviteText = `Hi ${manager ? manager.attributes.first_name : ''},

Welcome to LeggUP! We’re pleased to invite you to the LeggUP Billing Portal.

As we prepare for the launch of your LeggUP Talent Insurance program, the first step is to complete the set up of your billing information and add an active payment method in the system, this will ensure we can launch the program on time. We are pleased to offer the following options: Credit Card or ACH.

To add your payment method and billing information, please follow these steps:

Step 1: Log into your billing manager dashboard.
Step 2: Enter your billing information and payment method (Credit Card or ACH; if using ACH, see instructions attached) information. Confirm and save the changes.

Setup ACH
Complete the following steps to set up your bank account:
Step 1: Select a US bank account, search for your bank, and select it.
Step 2: Click Pay and agree to the terms of service.
Step 3: Initiate a link with your bank, and add your bank login credentials.
Step 4: Select your desired bank account and click Link Account.
Step 5: LeggUP will ask you to verify the Micro-deposit amount on your bank account.

Note: Your Bank might ask for the institution’s ID linked to your bank account. Please use the following IDs
18004858 - Stripe Payments Company
4270465600 - Stripe Payments Company

`;

  const [formData, setFormData] = useState({
    text: manager && manager.attributes.user_role === 'Billing Manager' ? defaultBillingInviteText : defaultInviteText,
  });

  const formSendSuccess = () => {
    swal({
      title: 'Invite Sent!',
      text: '',
      html: true,
      type: 'success',
      showCancelButton: false,
      confirmButtonText: 'Close',
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    axios
      .post(routes.api.team_leads.invite(manager.id), {
        ...values,
      })
      .then((resp) => {
        closeForm();
        formSendSuccess();
      });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextAreaField
        name="text"
        rows={10}
        label={(
          <>
            <span>Invite Text</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? 'Please, wait ...' : 'Send'}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? 'not-possible-click' : ''
          }`}
        />
      </div>
    </BaseForm>
  );
}
